// extracted by mini-css-extract-plugin
module.exports = {"root":"IntegrationDataPage_root__3nk8h","body":"IntegrationDataPage_body__1uMkP"};